import React, { Component } from "react";
import ComponentHeader from "./ComponentHeader";
import classnames from "classnames";
import styles from "./Components.local.scss";
import { number_format } from "Utils";
import _ from "i18n";
import ComponentActions from "./ComponentActions";

class ValueDescComponent extends Component {
  render() {
    const {
      slideId,
      isPreparePresentation,
      isComposition,
      component,
      isPresentation,
      hasComments,
      indicatorsExplanation,
      hasExplanation,
      layoutProps: { direction }
    } = this.props;

    const {
      componentId,
      labels,
      data: { account },
      config: { description, annexeAttachmentCategory }
    } = component;

    const {
      percentage,
      currentValue,
      diffValue,
      unit,
      notAvailable
    } = account[0];

    return (
      <div>
        <ComponentHeader
          slideId={slideId}
          percentage={percentage}
          title={labels}
          annexeAttachmentCategory={annexeAttachmentCategory}
          handleDisplayAnnexePDF={this.props.handleDisplayAnnexePDF}
          isComposition={isComposition}
          isPresentation={isPresentation}
          hasComments={hasComments}
          componentId={componentId}
          isPreparePresentation={isPreparePresentation}
          indicatorsExplanation={indicatorsExplanation}
          hasExplanation={hasExplanation}
          inSlideView={this.props.inSlideView}
        />
        <div
          className={classnames(
            styles.ValueDescAndBarChartComponent,
            styles.absolute_container,
            styles.flex_container,
            styles.align_container
          )}
        >
          {!this.props.inSlideView &&
            !this.props.isEmbedded && (
              <ComponentActions
                removeComponent={this.props.handleRemoveComponent}
                updateComponent={this.props.handleUpdateComponent}
                componentCase={this.props.ComponentCase}
                sideBar={"ComponentConfig"}
                component={"ValueDescComponent.png"}
              />
            )}
          <div
            className={classnames(
              "medium-12 small-12",
              styles.flex_container,
              styles.align_container
            )}
          >
            <div
              className={classnames(
                direction === "VERTICAL" ? "small-12" : "medium-5 small-5",
                styles.flex_container,
                styles.align_container
              )}
              style={direction ? { marginBottom: 5 } : null}
            >
              <span
                className={classnames("medium-12 small-12", styles.main_value)}
              >
                {notAvailable
                  ? currentValue
                  : number_format(currentValue, 2, ",", " ")}{" "}
                {unit !== "none" ? unit : ""}
              </span>
              <span
                className={classnames(
                  "medium-12 small-12",
                  styles.sub_value,
                  percentage > 0 ? styles.positive_value : styles.negative_value
                )}
              >
                {notAvailable
                  ? _("notAvailable")
                  : percentage > 0
                    ? _("increaseOf")
                    : _("decreaseOf")}{" "}
                <span className={styles.positive_value}>
                  {notAvailable ? "" : number_format(diffValue, 2, ",", " ")}{" "}
                  {unit !== "none" ? unit : ""}
                </span>
              </span>
              <span
                className={classnames("medium-12 small-12", styles.description)}
              >
                {description}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ValueDescComponent;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Components/ValueDescComponent.js